import './styles.scss';

import React, {useEffect, useState} from 'react';

import {useAppDispatch, useAppSelector} from '../../../../../hooks';
import {useOutsideClick} from '../../../../../hooks/useOutsideClick';
import {fetchAlertsMetadata} from '../../../../../slices/alertsMetadataSlice';
import {fetchNotifications, selectNotifications} from '../../../../../slices/notificationSlice';
import { NotificationUtil } from '../../../../../utils/NotificationUtil';
import {HeaderItemLink, HeaderItemLinkMode} from '../HeaderItemLink/HeaderItemLink';
import {HeaderNotificationsModal} from '../HeaderNotificationsModal/HeaderNotificationsModal';
import {UnreadCount} from '../UnreadCount/UnreadCount';

export const HeaderNotifications = () => {
    const dispatch = useAppDispatch();
    const notificationsState = useAppSelector(selectNotifications);
    const [showNotificationsMenu, setShowNotificationsMenu] = useState(false);
    const ref = useOutsideClick(() => {
        showNotificationsMenu && setShowNotificationsMenu(false);
    });

    const loadData = () => {
        dispatch(fetchNotifications({length: 5}));
        dispatch(fetchAlertsMetadata());
    };
    // eslint-disable-next-line
    useEffect(loadData, []);

    return (
        <div ref={ref} className='header-notifications'>
            <HeaderItemLink
                onClick={() => setShowNotificationsMenu(!showNotificationsMenu)}
                mode={HeaderItemLinkMode.NOTIFICATION}
            />
            <UnreadCount />
            {showNotificationsMenu && (
                <HeaderNotificationsModal
                    error={!!notificationsState.error}
                    loading={notificationsState.pending}
                    notifications={NotificationUtil.getRegularNotifications(notificationsState.value)}
                    onRetry={loadData}
                    onClose={() => setShowNotificationsMenu(false)}
                />
            )}
        </div>
    );
};
